/* ============================================================
   Cart Drawer Vitamii — interactions v3 (UI optimiste = ultra rapide)
   - Abonnement / poids : MAJ instantanée de l'UI au clic, puis synchro des
     chiffres depuis la réponse /cart/change (SANS re-render → pas de flicker).
   - Poids : instantané + debounced (un seul appel même en cliquant vite).
   - Cross-sell add : re-render natif (le nombre d'articles change).
   ============================================================ */
(function () {
  var copy = window.VitamiiCartI18n || {"estimated": "Livraison estimée ", "between": "entre le __START__ et le __END__", "codePrefix": "Code promo · ", "discount": "Réduction", "packDog2": "Pack - 2 Chiens", "packDog3": "Pack - 3 Chiens", "packCat2": "Pack - 2 Chats", "packCat3": "Pack - 3 Chats", "codeRemoved": "Code non cumulable avec l'abonnement, il a été retiré.", "freeUnlocked": "<strong>Livraison offerte débloquée</strong>", "freeRemaining": "Plus que <strong>__AMOUNT__</strong> pour la livraison offerte", "savings": "Vous économisez __AMOUNT__ grâce à votre abonnement", "deliveredPrefix": "Livré ", "rightPace": "au bon rythme", "dog": "chien", "idle": "Livré au rythme de votre __SPECIES__ · sans engagement", "frequency": "Livré __FREQUENCY__ · sans engagement", "chooseWeight": "Choisissez le poids de votre __SPECIES__", "codeSubscription": "Code non cumulable avec un abonnement, décochez « S'abonner » pour l'utiliser.", "codeInvalid": "Code invalide ou expiré, ou conditions non remplies (montant minimum, produits éligibles).", "retry": "Une erreur est survenue, réessayez."};
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var displayLocale = document.documentElement.lang || "fr-FR";
  function translated(name, values){ var text=copy[name]; Object.keys(values || {}).forEach(function(k){ text=text.replace(k, values[k]); }); return text; }
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble', 'cart-icon-bubble--mobile'];
  var addBusy = false;
  var weightTimer = null;
  var changeUrl = (window.routes && window.routes.cart_change_url) || rootUrl+'cart/change.js';
  var addUrl = (window.routes && window.routes.cart_add_url) || rootUrl+'cart/add.js';
  var OFFER_CODE = 'POUDRECART30';
  var OFFER_PRODUCT_HANDLE = 'poudre-dentaire-offre-panier';
  var OFFER_MARKER = 'poudre-dentaire';
  var LEGACY_OFFER_CODES = ['POUDRECART50', 'BAUMECART50'];
  var PACK_CODES = ['VTPACKDOG2', 'VTPACKDOG3', 'VTPACKCAT2', 'VTPACKCAT3'];
  var DOG_ONE_POT_VARIANTS = ['54703550792015','54703760507215','54704220537167','56393628483919','56399329526095','57394380472655'];
  var CAT_ONE_POT_VARIANTS = ['48906274636111','48906376675663','54704146448719','54704184852815','54704269885775'];

  /* ---------- estimation de livraison (2–3 jours ouvrés, hors WE + fériés FR) ---------- */
  function iso(d){ return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0'); }
  // Dimanche de Pâques (algorithme de Meeus/Butcher) → sert aux fériés mobiles.
  function easterSunday(Y){
    var a=Y%19, b=Math.floor(Y/100), c=Y%100, d=Math.floor(b/4), e=b%4,
        f=Math.floor((b+8)/25), g=Math.floor((b-f+1)/3),
        h=(19*a+b-d-g+15)%30, i=Math.floor(c/4), k=c%4,
        l=(32+2*e+2*i-h-k)%7, m=Math.floor((a+11*h+22*l)/451),
        mo=Math.floor((h+l-7*m+114)/31), da=((h+l-7*m+114)%31)+1;
    return new Date(Y, mo-1, da);
  }
  // Jours fériés français (métropole) calculés pour n'importe quelle année, mémoïsés.
  var feriesCache={};
  function feriesFor(year){
    if(feriesCache[year]) return feriesCache[year];
    var set={}, add=function(dt){ set[iso(dt)]=1; };
    // fixes : Jour de l'An, Fête du Travail, Victoire 1945, Fête nationale,
    //         Assomption, Toussaint, Armistice, Noël
    [[0,1],[4,1],[4,8],[6,14],[7,15],[10,1],[10,11],[11,25]].forEach(function(md){ add(new Date(year,md[0],md[1])); });
    // mobiles (Pâques) : Lundi de Pâques (+1), Ascension (+39), Lundi de Pentecôte (+50)
    var pa=easterSunday(year);
    [1,39,50].forEach(function(off){ var dt=new Date(pa); dt.setDate(dt.getDate()+off); add(dt); });
    feriesCache[year]=set; return set;
  }
  function isWorkday(d){ var w=d.getDay(); return w!==0 && w!==6 && !feriesFor(d.getFullYear())[iso(d)]; }
  function addWorkdays(s,n){ var d=new Date(s),c=0; while(c<n){ d.setDate(d.getDate()+1); if(isWorkday(d)) c++; } return d; }
  function computeEta(){
    try{
      var t=new Date(), lo=addWorkdays(t,2), hi=addWorkdays(t,3);
      var fmt=new Intl.DateTimeFormat(displayLocale,{day:'numeric',month:'long'});
      var same=lo.getMonth()===hi.getMonth()&&lo.getFullYear()===hi.getFullYear();
      var dates=translated('between', {__START__:same?lo.getDate():fmt.format(lo), __END__:fmt.format(hi)});
      var plain=copy.estimated+dates;
      // dates en corail (gras) ; on compare le textContent (sans balises) pour ne pas boucler avec l'observer.
      document.querySelectorAll('.vt-eta-text').forEach(function(el){
        if(el.textContent!==plain) el.innerHTML=esc(copy.estimated)+'<b class="vt-eta-d">'+esc(dates)+'</b>';
      });
    }catch(e){}
  }

  /* ---------- helpers ---------- */
  function euro(c){ return (c/100).toLocaleString(displayLocale,{minimumFractionDigits:2,maximumFractionDigits:2})+' €'; }
  function postJSON(url, payload){
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)}).then(function(r){return r.json();});
  }
  function getCart(){
    return fetch(rootUrl+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();});
  }
  function normCode(code){ return String(code||'').trim().toUpperCase(); }
  function cartCodeValues(cart){
    var out=[];
    (cart.discount_codes||[]).forEach(function(d){ var c=normCode(d.code); if(c && out.indexOf(c)===-1) out.push(c); });
    return out;
  }
  function uniqueCodes(codes){
    var out=[];
    (codes||[]).forEach(function(code){ var c=normCode(code); if(c && out.indexOf(c)===-1) out.push(c); });
    return out;
  }
  function sameCodes(a,b){
    a=uniqueCodes(a).sort(); b=uniqueCodes(b).sort();
    return a.length===b.length && a.every(function(code,i){ return code===b[i]; });
  }
  function setDiscountCodes(codes){ return postJSON(rootUrl+'cart/update.js',{discount:uniqueCodes(codes).join(',')}); }
  function codeApplicable(cart, code){
    code=normCode(code);
    return (cart.discount_codes||[]).some(function(d){ return normCode(d.code)===code && d.applicable; });
  }
  function packCodesForItems(cart){
    var dog=0, cat=0;
    (cart.items||[]).forEach(function(item){
      if(item.selling_plan_allocation) return;
      var id=String(item.variant_id||'');
      if(DOG_ONE_POT_VARIANTS.indexOf(id)!==-1) dog+=item.quantity||0;
      if(CAT_ONE_POT_VARIANTS.indexOf(id)!==-1) cat+=item.quantity||0;
    });
    var codes=[];
    if(dog>=3) codes.push('VTPACKDOG3'); else if(dog===2) codes.push('VTPACKDOG2');
    if(cat>=3) codes.push('VTPACKCAT3'); else if(cat===2) codes.push('VTPACKCAT2');
    return codes;
  }
  function isPowderUpsellLine(item){
    return !!(item && item.handle===OFFER_PRODUCT_HANDLE && item.properties && item.properties._vitamii_upsell===OFFER_MARKER);
  }
  // Applique un changement puis synchronise depuis /cart.js.
  // IMPORTANT : la réponse de /cart/change.js a un total_price parfois gonflé
  // par une app tierce (ex. Point Relais/Colissimo = +2,90 €). On ne se fie
  // JAMAIS à son total ; on relit /cart.js (propre) avant d'afficher.
  function changeThenSync(body){
    return postJSON(changeUrl, body).then(getCart).then(syncFromCart);
  }

  /* ---------- récap sous-total : MAJ des lignes depuis l'objet cart ---------- */
  function setMoney(sel, c, neg){ var el=document.querySelector(sel); if(el) el.textContent=(neg?'−':'')+euro(c); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function discountLabel(title,type){
    var code=normCode(title);
    if(code==='VTPACKDOG2') return copy.packDog2;
    if(code==='VTPACKDOG3') return copy.packDog3;
    if(code==='VTPACKCAT2') return copy.packCat2;
    if(code==='VTPACKCAT3') return copy.packCat3;
    return type==='discount_code' ? (copy.codePrefix+esc(title)) : (esc(title)||copy.discount);
  }
  // regroupe les remises (line-level + cart-level) par titre+type, libellées code vs auto
  function renderDiscountLines(cart){
    var cont=document.querySelector('.vt-recap__discounts'); if(!cont) return;
    var map={}, order=[];
    function add(title,type,amt){ var k=(title||'')+'\u0000'+(type||''); if(map[k]==null){map[k]=0;order.push(k);} map[k]+=amt; }
    (cart.items||[]).forEach(function(it){ (it.line_level_discount_allocations||[]).forEach(function(a){ var da=a.discount_application||{}; add(da.title,da.type,a.amount); }); });
    (cart.cart_level_discount_applications||[]).forEach(function(d){ add(d.title,d.type,d.total_allocated_amount); });
    var html='';
    order.forEach(function(k){ var amt=map[k]; if(amt<=0) return; var p=k.split('\u0000');
      var label = discountLabel(p[0],p[1]);
      html+='<div class="vt-recap__row vt-recap__row--disc"><span>'+label+'</span><span>−'+euro(amt)+'</span></div>'; });
    cont.innerHTML=html;
  }
  function updateRecap(cart){
    var recap=document.querySelector('.vt-recap'); if(!recap) return;
    var sav=0;
    (cart.items||[]).forEach(function(it){ var a=it.selling_plan_allocation; if(a && a.compare_at_price){ sav += (a.compare_at_price - a.price)*it.quantity; } });
    var disc=cart.total_discount||0;
    recap.classList.toggle('vt-recap--flat', !(sav>0 || disc>0)); // aucune remise → seule la ligne Total
    setMoney('.vt-recap__val--subtotal', cart.total_price + sav + disc); // prix plein
    var aboRow=recap.querySelector('.vt-recap__row--abo');
    if(aboRow){ aboRow.style.display = sav>0?'':'none'; setMoney('.vt-recap__val--abo', sav, true); }
    renderDiscountLines(cart);
    setMoney('.vt-recap__val--total', cart.total_price);
  }

  /* ---------- code promo vs abonnement (non cumulable) ----------
     Détecte si un code promo a sauté suite à un abonnement. Comme Shopify retire le code
     ET peut réordonner les lignes, on fait un RE-RENDER complet pour tout resynchroniser
     (prix des lignes, badges remise natifs, récap, bloc promo), puis on affiche le message. */
  function isInternalOfferCode(code){
    code=normCode(code);
    return code===OFFER_CODE || LEGACY_OFFER_CODES.indexOf(code)!==-1 || PACK_CODES.indexOf(code)!==-1;
  }
  function cartHasCustomerCode(cart){
    var found=false;
    (cart.items||[]).forEach(function(it){ (it.line_level_discount_allocations||[]).forEach(function(a){ var d=a.discount_application||{}; if(d.type==='discount_code' && !isInternalOfferCode(d.title)) found=true; }); });
    (cart.cart_level_discount_applications||[]).forEach(function(d){ if(d.type==='discount_code' && !isInternalOfferCode(d.title)) found=true; });
    return found;
  }
  function syncPromo(cart){
    var promo=document.querySelector('.vt-promo'); if(!promo) return false;
    var hasCode=cartHasCustomerCode(cart);
    var chip=promo.querySelector('.vt-promo__chip');
    if(!hasCode && chip){
      // code retiré (non cumulable avec l'abonnement) → re-render complet + message
      reloadDrawer().then(function(){
        var err=document.querySelector('.vt-promo [data-promo-err]');
        if(err){ err.textContent=copy.codeRemoved; err.hidden=false; }
      }).catch(function(){});
      return true;
    }
    if(hasCode && !chip){ reloadDrawer().catch(function(){}); return true; }
    return false;
  }

  /* ---------- synchro des chiffres depuis l'objet cart (PAS de re-render) ---------- */
  function syncFromCart(cart){
    if(!cart || cart.total_price==null) return;
    if(syncPromo(cart)) return; // re-render complet en cours → inutile de patcher l'ancien DOM
    // Dès qu'une remise est en jeu (Pack auto, code…), la structure prix (barré empilé) + badge
    // est trop complexe pour un patch optimiste → on laisse le SERVEUR tout recalculer/réafficher.
    if((cart.total_discount||0) > 0 || document.querySelector('.drawer__cart-item .discounts__discount')){ reloadDrawer().catch(function(){}); return; }
    updateRecap(cart);
    updateProgress(cart.total_price);
    (cart.items||[]).forEach(function(it,i){
      var line=document.getElementById('CartDrawer-Item-'+(i+1)); if(!line) return;
      var p=line.querySelector('.drawer__cart-item__totals .price, .drawer__cart-item__totals .price__sale');
      if(p){ p.innerHTML = (it.original_line_price!==it.final_line_price)
        ? '<s class="vt-strike">'+euro(it.original_line_price)+'</s> '+euro(it.final_line_price)
        : euro(it.final_line_price); }
    });
  }
  function updateProgress(total){
    var pg=document.querySelector('.vt-progress'); if(!pg) return;
    var th=+pg.dataset.threshold||6000, rem=th-total, pct=Math.min(100,total*100/th);
    var f=pg.querySelector('.vt-progress__fill'); if(f) f.style.width=pct+'%';
    var ic=pg.querySelector('.vt-progress__ic'); if(ic) ic.classList.toggle('is-reached', rem<=0);
    var tx=pg.querySelector('.vt-progress__text');
    if(tx) tx.innerHTML = rem<=0 ? copy.freeUnlocked
      : translated('freeRemaining', {__AMOUNT__:euro(rem)});
  }
  function updateSavings(sav){
    var el=document.querySelector('.vt-foot-save');
    if(sav>0){
      if(!el){ var eta=document.querySelector('.vt-eta'); el=document.createElement('p'); el.className='vt-foot-save';
        if(eta&&eta.parentNode) eta.parentNode.insertBefore(el,eta); }
      el.textContent=translated('savings', {__AMOUNT__:euro(sav)}); el.style.display='';
    } else if(el){ el.style.display='none'; }
  }

  /* ---------- UI optimiste de la ligne (instantané) ---------- */
  function freqFromText(t){ return t ? t.replace(copy.deliveredPrefix,'').split(' · ')[0] : copy.rightPace; }
  function speciesOf(line){
    var cb=line && line.querySelector('.vt-sub__check');
    return (cb && cb.dataset.species) || copy.dog;
  }
  function setLineSubUI(line, on, freqLabel){
    var w=line.querySelector('.vt-weights'); if(w) w.classList.toggle('mm-none', !on);
    var sub=line.querySelector('.vt-sub__sub');
    var idle=translated('idle', {__SPECIES__:speciesOf(line)});
    if(sub) sub.textContent = on ? (freqLabel ? (translated('frequency', {__FREQUENCY__:freqLabel})) : idle) : idle;
  }

  /* ---------- ABONNEMENT : case (capture + stopPropagation) ---------- */
  document.addEventListener('change', function(e){
    var cb=e.target.closest && e.target.closest('.vt-sub__check'); if(!cb) return;
    e.stopPropagation();
    var on=cb.checked, line=cb.closest('.drawer__cart-item');
    // 1) instantané
    setLineSubUI(line, on, null);
    if(on) line.querySelectorAll('.vt-weights__pills button').forEach(function(b){ b.classList.remove('active'); });
    else clearWeightFlag(line);
    // 2) mutation + synchro chiffres (sans re-render).
    //    On cible la ligne par son INDEX (stable) : la clé change quand le plan change.
    changeThenSync({line:parseInt(cb.dataset.line,10)||1, quantity:parseInt(cb.dataset.qty,10)||1, selling_plan: on?cb.dataset.plan:null})
      .catch(function(){});
  }, true);

  /* ---------- ABONNEMENT : poids (instantané + debounced) ---------- */
  document.addEventListener('click', function(e){
    var pill=e.target.closest && e.target.closest('.vt-weights__pills button'); if(!pill) return;
    var wrap=pill.closest('.vt-weights'); if(!wrap || !pill.dataset.plan) return;
    var line=wrap.closest('.drawer__cart-item'), freq=pill.dataset.freq;
    // instantané
    wrap.querySelectorAll('button').forEach(function(b){ b.classList.remove('active'); });
    pill.classList.add('active');
    clearWeightFlag(line);
    var sub=line.querySelector('.vt-sub__sub'); if(sub) sub.textContent=translated('frequency', {__FREQUENCY__:freq});
    // mutation debounced (prix inchangé → pas de synchro nécessaire)
    clearTimeout(weightTimer);
    var line=parseInt(wrap.dataset.line,10)||1, qty=parseInt(wrap.dataset.qty,10)||1, plan=pill.dataset.plan;
    weightTimer=setTimeout(function(){ changeThenSync({line:line, quantity:qty, selling_plan:plan}).catch(function(){}); }, 250);
  });

  /* ---------- VALIDATION : abonné SANS poids choisi → bloque le checkout ---------- */
  function subItemsMissingWeight(){
    var out=[];
    document.querySelectorAll('.drawer__cart-item').forEach(function(item){
      var cb=item.querySelector('.vt-sub__check');
      if(cb && cb.checked){
        var w=item.querySelector('.vt-weights');
        if(w && !w.classList.contains('mm-none') && !w.querySelector('.vt-weights__pills button.active')){ out.push(item); }
      }
    });
    return out;
  }
  function flagWeight(item){
    var w=item.querySelector('.vt-weights'); if(!w) return;
    var msg=w.querySelector('.vt-weights__need');
    if(!msg){
      msg=document.createElement('div'); msg.className='vt-weights__need'; msg.setAttribute('role','alert');
      msg.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h16.9a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>'+esc(translated('chooseWeight', {__SPECIES__:speciesOf(item)}));
      w.appendChild(msg);
    }
    w.classList.add('vt-weights--need');
    w.classList.remove('vt-weights--shake'); void w.offsetWidth; w.classList.add('vt-weights--shake');
  }
  function clearWeightFlag(item){
    if(!item) return; var w=item.querySelector('.vt-weights'); if(!w) return;
    w.classList.remove('vt-weights--need','vt-weights--shake');
  }
  function blockIfMissingWeight(e){
    var bad=subItemsMissingWeight();
    if(!bad.length) return true;
    if(e){ e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation(); }
    bad.forEach(flagWeight);
    var w=bad[0].querySelector('.vt-weights'); if(w) w.scrollIntoView({behavior:'smooth', block:'center'});
    return false;
  }
  document.addEventListener('submit', function(e){ var f=e.target; if(f && f.id==='CartDrawer-Form') blockIfMissingWeight(e); }, true);
  document.addEventListener('click', function(e){ var b=e.target.closest && e.target.closest('#CartDrawer-Checkout'); if(b) blockIfMissingWeight(e); }, true);

  /* ---------- CROSS-SELL : ajout (re-render natif, le nb d'articles change) ---------- */
  function innerFromSection(html, sel){ try{ var d=new DOMParser().parseFromString(html,'text/html'); var el=d.querySelector(sel); return el?el.innerHTML:null; }catch(e){ return null; } }
  function renderDrawer(state){
    if(!state || !state.sections) return;
    var inner=innerFromSection(state.sections['cart-drawer'], '.drawer__inner');
    var dest=document.querySelector('cart-drawer .drawer__inner');
    if(inner!=null && dest) dest.innerHTML=inner;
    ['cart-icon-bubble','cart-icon-bubble--mobile'].forEach(function(id){
      if(!state.sections[id]) return;
      var node=document.getElementById(id), html=innerFromSection(state.sections[id], '.shopify-section');
      if(node && html!=null) node.innerHTML=html;
    });
    if(window.Loox && window.Loox.refresh){ try{ window.Loox.refresh(); }catch(e){} }
    computeEta();
    paintGift();
  }
  document.addEventListener('click', function(e){
    var btn=e.target.closest && e.target.closest('.vt-xadd'); if(!btn) return;
    e.preventDefault(); if(addBusy) return; addBusy=true; btn.classList.add('is-loading');
    var addItem={id:btn.dataset.variant, quantity:1};
    if(btn.dataset.upsellOffer){ addItem.properties={'_vitamii_upsell':btn.dataset.upsellOffer}; }
    postJSON(addUrl,{items:[addItem], sections:SECTIONS, sections_url:window.location.pathname})
      .then(renderDrawer).catch(function(){})
      .then(function(){ addBusy=false; btn.classList.remove('is-loading'); });
  });

  /* ---------- CROSS-SELL : flèches ---------- */
  document.addEventListener('click', function(e){
    var arr=e.target.closest && e.target.closest('.vt-xsell__arrow'); if(!arr) return;
    var track=arr.closest('.vt-xsell').querySelector('.vt-xsell__track'); if(!track) return;
    var card=track.firstElementChild, step=(card?card.getBoundingClientRect().width:200)+10;
    track.scrollBy({left: parseInt(arr.dataset.dir,10)*step, behavior:'smooth'});
  });

  /* ---------- CROSS-SELL : compteur "i/N" + points suivent le scroll (délégué en capture, survit aux re-renders) ---------- */
  document.addEventListener('scroll', function(e){
    var tr=e.target && e.target.closest && e.target.closest('.vt-xsell__track'); if(!tr) return;
    var cards=tr.children; if(!cards.length) return;
    var step=cards[0].getBoundingClientRect().width+10;
    var i=Math.round(tr.scrollLeft/step); if(i<0)i=0; if(i>cards.length-1)i=cards.length-1;
    var xs=tr.closest('.vt-xsell'); if(!xs) return;
    xs.querySelectorAll('.vt-xsell__dots i').forEach(function(d,k){ d.classList.toggle('on', k===i); });
    var c=xs.querySelector('.vt-xsell__count'); if(c) c.textContent=(i+1)+' / '+cards.length;
    var pa=xs.querySelector('.vt-bom__nav .vt-xsell__arrow[data-dir="-1"]');
    var na=xs.querySelector('.vt-bom__nav .vt-xsell__arrow[data-dir="1"]');
    if(pa||na){ var maxSL=tr.scrollWidth-tr.clientWidth; if(pa) pa.classList.toggle('is-off', tr.scrollLeft<=2); if(na) na.classList.toggle('is-off', tr.scrollLeft>=maxSL-2); }
  }, true);

  /* ---------- CODE PROMO : application / retrait (via /discount/ + re-render) ----------
     Shopify n'applique pas les codes via l'AJAX cart ; on passe par le permalien
     /discount/CODE (pose le cookie de remise), puis on recharge la section du tiroir. */
  function reloadDrawer(){
    return fetch(rootUrl+'?sections='+SECTIONS.join(','), {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); }).then(function(secs){ renderDrawer({sections:secs}); });
  }
  // titres des remises de TYPE code présentes dans le panier (line + cart level)
  function codeDiscTitles(cart){
    var t=[];
    (cart.items||[]).forEach(function(it){ (it.line_level_discount_allocations||[]).forEach(function(a){ var da=a.discount_application||{}; if(da.type==='discount_code'&&da.title&&!isInternalOfferCode(da.title)) t.push(da.title); }); });
    (cart.cart_level_discount_applications||[]).forEach(function(d){ if(d.type==='discount_code'&&d.title&&!isInternalOfferCode(d.title)) t.push(d.title); });
    return t;
  }
  document.addEventListener('click', function(e){
    var btn=e.target.closest && e.target.closest('[data-promo-apply]'); if(!btn) return;
    var wrap=btn.closest('.vt-promo'), input=wrap && wrap.querySelector('[data-promo-input]');
    var code=input ? input.value.trim() : ''; if(!code) return;
    code=normCode(code);
    var err=wrap.querySelector('[data-promo-err]'); if(err) err.hidden=true;
    if(!btn.dataset.lbl) btn.dataset.lbl=btn.textContent;
    btn.disabled=true; btn.textContent='…';
    getCart()
      .then(function(cart){
        var desired=cartCodeValues(cart).filter(function(c){ return c!==code; });
        // GESTE a une priorité commerciale absolue : on retire les codes Pack internes
        // avant son évaluation. Les remises ne se cumulent donc jamais sur les mêmes pots.
        if(code==='GESTE') desired=desired.filter(function(c){ return PACK_CODES.indexOf(c)===-1; });
        desired.push(code);
        return setDiscountCodes(desired);
      })
      .then(getCart)
      .then(function(cart){
        if(codeApplicable(cart,code)) return reloadDrawer();
        // Code réellement invalide : on le retire et on restaure immédiatement les Packs.
        var desired=cartCodeValues(cart).filter(function(c){ return c!==code && PACK_CODES.indexOf(c)===-1; });
        desired=desired.concat(packCodesForItems(cart));
        return setDiscountCodes(desired).then(function(){ return tryGiftCard(code); }).then(function(giftOk){
          if(giftOk){ if(input) input.value=''; btn.disabled=false; btn.textContent=btn.dataset.lbl; return; }
          var hasSub=(cart.items||[]).some(function(it){ return it.selling_plan_allocation; });
          var msg=hasSub
            ? copy.codeSubscription
            : copy.codeInvalid;
          if(err){ err.textContent=msg; err.hidden=false; }
          btn.disabled=false; btn.textContent=btn.dataset.lbl;
        });
      })
      .catch(function(){ if(err){ err.textContent=copy.retry; err.hidden=false; } btn.disabled=false; btn.textContent=btn.dataset.lbl; });
  });
  document.addEventListener('click', function(e){
    var x=e.target.closest && e.target.closest('[data-promo-remove]'); if(!x) return;
    x.disabled=true;
    // Retire le code client puis restaure les codes Pack correspondant aux quantités.
    getCart().then(function(cart){
      var desired=cartCodeValues(cart).filter(function(c){ return isInternalOfferCode(c) && PACK_CODES.indexOf(c)===-1; });
      desired=desired.concat(packCodesForItems(cart));
      return setDiscountCodes(desired);
    }).catch(function(){})
      .then(function(){ return reloadDrawer(); }).catch(function(){ x.disabled=false; });
  });
  document.addEventListener('click', function(e){
    var t=e.target.closest && e.target.closest('[data-promo-toggle]'); if(!t) return;
    var wrap=t.closest('.vt-promo'), rev=wrap && wrap.querySelector('[data-promo-reveal]');
    if(rev) rev.hidden=false;
    t.hidden=true;
    var input=wrap && wrap.querySelector('[data-promo-input]'); if(input) input.focus();
  });
  document.addEventListener('keydown', function(e){
    if(e.key!=='Enter') return;
    var input=e.target.closest && e.target.closest('[data-promo-input]'); if(!input) return;
    e.preventDefault();
    var btn=input.closest('.vt-promo').querySelector('[data-promo-apply]'); if(btn) btn.click();
  });


  /* ---------- CARTE CADEAU : saisie dans le même champ que le code promo ----------
     L'AJAX cart (/cart/update.js) ne sait appliquer que des codes promo. Une carte cadeau
     passe par la Storefront API (cartGiftCardCodesAdd) sur le MÊME panier (cookie `cart`),
     elle est donc reprise telle quelle au checkout. Le tiroir étant re-rendu en Liquid
     (qui ne connaît pas les cartes cadeaux), la pastille est repeinte en JS après chaque rendu. */
  var giftCopy=(document.documentElement.lang||'').indexOf('en')===0
    ? {chip:'Gift card ···· __LAST__ · −__AMOUNT__ at checkout', note:'The gift card is deducted at the payment step.', remove:'Remove gift card'}
    : {chip:'Carte cadeau ···· __LAST__ · −__AMOUNT__ au paiement', note:'Le montant de la carte cadeau est déduit à l\'étape du paiement.', remove:'Retirer la carte cadeau'};
  var giftCards=[];
  function sfConfig(){
    var api=window.DeployerStorefrontApi, c=(api && api.config) || {};
    return { token: c.STOREFRONT_ACCESS_TOKEN || '8d0660b93af575c9b69e3fb6382e84a4', version: c.API_VERSION || '2025-01' };
  }
  function sfCartId(){
    var m=document.cookie.match(/(?:^|;\s*)cart=([^;]*)/);
    return m && m[1] ? 'gid://shopify/Cart/'+decodeURIComponent(m[1]) : null;
  }
  function sfRequest(query, variables){
    var c=sfConfig();
    return fetch('/api/'+c.version+'/graphql.json', {
      method:'POST',
      headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':c.token},
      body:JSON.stringify({query:query, variables:variables})
    }).then(function(r){ return r.json(); }).then(function(res){
      if(res.errors && res.errors.length) throw res.errors[0];
      return res.data;
    });
  }
  var GIFT_FIELDS='appliedGiftCards{ id lastCharacters amountUsed{ amount } }';
  function setGiftCards(list){ giftCards=list||[]; paintGift(); }
  function refreshGift(){
    var id=sfCartId(); if(!id){ setGiftCards([]); return Promise.resolve(); }
    return sfRequest('query($id:ID!){ cart(id:$id){ '+GIFT_FIELDS+' } }', {id:id})
      .then(function(d){ setGiftCards(d.cart ? d.cart.appliedGiftCards : []); })
      .catch(function(){});
  }
  // Renvoie true si le code a été accepté comme carte cadeau.
  function tryGiftCard(code){
    var clean=String(code||'').replace(/[\s-]/g,'').toUpperCase(), id=sfCartId();
    if(!id || clean.length<8) return Promise.resolve(false);
    return sfRequest('mutation($id:ID!,$codes:[String!]!){ cartGiftCardCodesAdd(cartId:$id, giftCardCodes:$codes){ cart{ '+GIFT_FIELDS+' } userErrors{ message } } }', {id:id, codes:[clean]})
      .then(function(d){
        var cart=d.cartGiftCardCodesAdd && d.cartGiftCardCodesAdd.cart; if(!cart) return false;
        setGiftCards(cart.appliedGiftCards);
        var last=clean.slice(-4);
        return (cart.appliedGiftCards||[]).some(function(g){ return String(g.lastCharacters||'').toUpperCase()===last; });
      })
      .catch(function(){ return false; });
  }
  function paintGift(){
    var wrap=document.querySelector('.vt-promo'); if(!wrap) return;
    var box=wrap.querySelector('.vt-gift');
    var sig=giftCards.map(function(g){ return g.id+':'+(g.amountUsed&&g.amountUsed.amount); }).join('|');
    if(box && box.dataset.sig===sig) return; // déjà à jour → évite de boucler avec le MutationObserver
    if(box) box.remove();
    if(!giftCards.length) return;
    var html='';
    giftCards.forEach(function(g){
      var amt=euro(Math.round(parseFloat((g.amountUsed&&g.amountUsed.amount)||0)*100));
      html+='<div class="vt-promo__chip"><span class="vt-promo__l"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg><span>'
        +esc(giftCopy.chip.replace('__LAST__', g.lastCharacters||'').replace('__AMOUNT__', amt))
        +'</span></span><button type="button" class="vt-promo__x" data-gift-remove="'+esc(g.id)+'" aria-label="'+esc(giftCopy.remove)+'"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>';
    });
    html+='<p class="vt-gift__note">'+esc(giftCopy.note)+'</p>';
    box=document.createElement('div'); box.className='vt-gift'; box.dataset.sig=sig; box.innerHTML=html;
    wrap.insertBefore(box, wrap.firstChild);
  }
  document.addEventListener('click', function(e){
    var x=e.target.closest && e.target.closest('[data-gift-remove]'); if(!x) return;
    var id=sfCartId(); if(!id) return;
    x.disabled=true;
    sfRequest('mutation($id:ID!,$ids:[ID!]!){ cartGiftCardCodesRemove(cartId:$id, appliedGiftCardIds:$ids){ cart{ '+GIFT_FIELDS+' } } }', {id:id, ids:[x.dataset.giftRemove]})
      .then(function(d){ var cart=d.cartGiftCardCodesRemove && d.cartGiftCardCodesRemove.cart; if(cart) setGiftCards(cart.appliedGiftCards); else return refreshGift(); })
      .catch(function(){ x.disabled=false; });
  });

  /* ---------- recalcul de l'ETA après le re-render natif du drawer ----------
     Le thème remplace tout `.drawer__inner` à chaque MAJ qté / suppression →
     `.vt-eta-text` repasse au placeholder « Livraison estimée… ». On observe le
     host `cart-drawer` (persistant) et on relance computeEta après chaque rerender. */
  /* ---------- OFFRE POUDRE : code interne -30% auto-injecté ----------
     IMPORTANT : Shopify garde dans cart.discount_codes les codes NON applicables
     (ex. un code resté en cookie mais inapplicable au panier courant, type GESTE).
     On raisonne donc sur le flag `applicable`, jamais sur la simple présence :
       - on (ré)applique POUDRECART30 uniquement à une poudre ajoutée par la carte d'upsell ;
       - une poudre achetée normalement reste éligible aux promotions client, dont GESTE ;
       - un code inapplicable resté en mémoire ne doit JAMAIS bloquer l'offre poudre ;
       - on respecte en revanche un code CLIENT réellement actif (applicable). */
  var packBusy=false, packPromise=Promise.resolve(false);
  function autoPackCodes(){
    if(packBusy) return packPromise;
    packBusy=true;
    packPromise=getCart().then(function(cart){
      var current=cartCodeValues(cart);
      var desired=current.filter(function(c){ return PACK_CODES.indexOf(c)===-1; });
      var hasGeste=current.indexOf('GESTE')!==-1;
      if(!hasGeste) desired=desired.concat(packCodesForItems(cart));
      if(sameCodes(current,desired)) return false;
      return setDiscountCodes(desired)
        .then(reloadDrawer)
        .then(function(){ return true; });
    }).catch(function(){ return false; }).then(function(changed){ packBusy=false; return changed; });
    return packPromise;
  }

  /* La remise Pack est pilotée par code interne. Avant tout départ au checkout,
     on attend sa synchronisation pour qu'une MAJ de quantité et le clic suivant
     ne puissent jamais envoyer un panier avec une remise périmée. */
  var checkoutRelease=false;
  function syncBeforeCheckout(e,kind){
    if(checkoutRelease) return;
    if(!blockIfMissingWeight(e)) return;
    e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation();
    autoPackCodes().then(function(){
      checkoutRelease=true;
      var form=document.getElementById('CartDrawer-Form');
      var button=document.getElementById('CartDrawer-Checkout');
      if(kind==='click' && button) button.click();
      else if(form){
        if(form.requestSubmit) form.requestSubmit(button||undefined);
        else form.submit();
      }
      setTimeout(function(){ checkoutRelease=false; },0);
    });
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest && e.target.closest('#CartDrawer-Checkout');
    if(b) syncBeforeCheckout(e,'click');
  },true);
  document.addEventListener('submit',function(e){
    if(e.target && e.target.id==='CartDrawer-Form') syncBeforeCheckout(e,'submit');
  },true);

  var offerBusy=false;
  function autoOffer(){
    if(offerBusy) return;
    getCart().then(function(c){
      var codes=c.discount_codes||[];
      var offerOk     = codes.some(function(d){ return d.code===OFFER_CODE && d.applicable; });
      var offerThere  = codes.some(function(d){ return d.code===OFFER_CODE; });
      var otherActive = codes.some(function(d){ return !isInternalOfferCode(d.code) && d.applicable; });
      var eligible=(c.items||[]).some(function(it){ return isPowderUpsellLine(it) && !it.selling_plan_allocation; });
      // On (ré)applique tant que la poudre n'a pas sa remise — MÊME si un code client est actif :
      // s'il est cumulable (ex. GESTE) l'offre poudre s'ajoute, s'il ne l'est pas Shopify la
      // refuse (elle reste listée inapplicable). Anti-boucle : on ne retente PAS quand le code
      // poudre est déjà présent-mais-inapplicable À CAUSE d'un code client actif (slot pris).
      if(eligible && !offerOk && !(offerThere && otherActive)){
        offerBusy=true;
        fetch(rootUrl+'discount/'+OFFER_CODE,{headers:{'Accept':'text/html'}}).then(function(){ offerBusy=false; return reloadDrawer(); }).catch(function(){ offerBusy=false; });
      } else if(!eligible && offerThere && !otherActive){
        // plus aucune ligne issue de l'upsell (ou uniquement en abonnement) → nettoyage
        offerBusy=true;
        setDiscountCodes(cartCodeValues(c).filter(function(code){ return code!==OFFER_CODE; }))
          .then(function(){ offerBusy=false; return reloadDrawer(); }).catch(function(){ offerBusy=false; });
      }
    }).catch(function(){});
  }

  function observeDrawer(){
    var host=document.querySelector('cart-drawer')||document.getElementById('CartDrawer');
    if(!host||!window.MutationObserver) return;
    var pending=false;
    new MutationObserver(function(){
      if(pending) return; pending=true;
      setTimeout(function(){ pending=false; computeEta(); paintGift(); autoPackCodes().then(autoOffer); }, 0); // debounce le burst de mutations
    }).observe(host, {childList:true, subtree:true});
  }

  function initEta(){ computeEta(); refreshGift(); autoPackCodes().then(autoOffer); observeDrawer(); }
  if(document.readyState!=='loading') initEta();
  else document.addEventListener('DOMContentLoaded', initEta);
})();
